
export default function WhistlerMarket() {
  const stats = [
    {
      value: '$425',
      label: 'Average Nightly Rate',
      description: 'Peak ski season rates can exceed $800/night for premium properties'
    },
    {
      value: '68%',
      label: 'Average Occupancy',
      description: 'Strong dual-season demand with winter and summer peaks'
    },
    {
      value: '3M+',
      label: 'Annual Visitors',
      description: 'World-class destination attracting global travelers'
    },
    {
      value: '$95K',
      label: 'Avg Annual Revenue',
      description: 'Top performers in prime locations earn $150K+'
    }
  ];

  const seasonalTrends = [
    {
      season: 'Winter Peak (Dec-Mar)',
      occupancy: '85%',
      rate: '$550',
      notes: 'Ski season drives highest demand and premium rates'
    },
    {
      season: 'Spring Shoulder (Apr-May)',
      occupancy: '45%',
      rate: '$275',
      notes: 'Quieter period between ski and summer seasons'
    },
    {
      season: 'Summer Peak (Jun-Sep)',
      occupancy: '78%',
      rate: '$350',
      notes: 'Mountain biking, hiking, and festivals drive strong demand'
    },
    {
      season: 'Fall Shoulder (Oct-Nov)',
      occupancy: '40%',
      rate: '$250',
      notes: 'Thanksgiving weekend spike, otherwise quieter'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-[#F8F8F8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Market Insights
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Whistler STR Market Performance
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            As North America&apos;s premier ski resort and a year-round outdoor destination, Whistler offers exceptional STR revenue potential with strong dual-season demand.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-all"
            >
              <div className="text-4xl font-bold text-[#882629] mb-2">{stat.value}</div>
              <div className="text-lg font-semibold text-[#505A5A] mb-2">{stat.label}</div>
              <p className="text-sm text-[#505A5A]/70">{stat.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-8 lg:p-10">
          <h3 className="text-2xl font-semibold text-[#505A5A] mb-8 text-center">
            Seasonal Performance Trends
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b-2 border-[#E5E5E5]">
                  <th className="px-4 py-3 text-left font-semibold text-[#505A5A]">Season</th>
                  <th className="px-4 py-3 text-center font-semibold text-[#505A5A]">Occupancy</th>
                  <th className="px-4 py-3 text-center font-semibold text-[#505A5A]">Avg Rate</th>
                  <th className="px-4 py-3 text-left font-semibold text-[#505A5A]">Market Notes</th>
                </tr>
              </thead>
              <tbody>
                {seasonalTrends.map((trend) => (
                  <tr key={trend.season} className="border-b border-[#E5E5E5]">
                    <td className="px-4 py-4 font-medium text-[#505A5A]">{trend.season}</td>
                    <td className="px-4 py-4 text-center">
                      <span className="bg-[#882629]/10 text-[#882629] px-3 py-1 rounded-full text-sm font-medium">
                        {trend.occupancy}
                      </span>
                    </td>
                    <td className="px-4 py-4 text-center font-semibold text-[#505A5A]">{trend.rate}</td>
                    <td className="px-4 py-4 text-[#505A5A]/70">{trend.notes}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="bg-white rounded-2xl p-6 flex items-start gap-4">
            <div className="w-12 h-12 bg-[#882629]/10 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-ski-line text-xl text-[#882629]"></i>
            </div>
            <div>
              <h4 className="font-semibold text-[#505A5A] mb-1">World-Class Skiing</h4>
              <p className="text-sm text-[#505A5A]/70">8,100+ acres of skiable terrain across two mountains draws skiers from around the globe.</p>
            </div>
          </div>
          <div className="bg-white rounded-2xl p-6 flex items-start gap-4">
            <div className="w-12 h-12 bg-[#882629]/10 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-bike-line text-xl text-[#882629]"></i>
            </div>
            <div>
              <h4 className="font-semibold text-[#505A5A] mb-1">Summer Adventures</h4>
              <p className="text-sm text-[#505A5A]/70">Mountain biking, hiking, golf, and zip-lining create strong summer tourism demand.</p>
            </div>
          </div>
          <div className="bg-white rounded-2xl p-6 flex items-start gap-4">
            <div className="w-12 h-12 bg-[#882629]/10 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-calendar-event-line text-xl text-[#882629]"></i>
            </div>
            <div>
              <h4 className="font-semibold text-[#505A5A] mb-1">Major Events</h4>
              <p className="text-sm text-[#505A5A]/70">Crankworx, Ironman, and numerous festivals drive premium booking periods.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
